import { render, staticRenderFns } from "./DeviceInfoAdequacaoTempInt.vue?vue&type=template&id=63d3fec2&"
import script from "./DeviceInfoAdequacaoTempInt.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoAdequacaoTempInt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports